"use strict";
//This file defines the default system roles
var USER_GROUPS = {
    ENTITY: {
        ADMINISTRATOR: {
            default_group_name: 'Administrators',
            role_id: 'client_admin',
            role_name: 'client admin',
            classname: 'entity_administrator',
        },
        USER: {
            default_group_name: 'Users',
            role_id: 'client_user',
            role_name: 'client user',
            classname: 'entity_user',
        },
        COMPLIANCE: {
            default_group_name: 'Compliance',
            role_id: 'client_compliance',
            role_name: 'client_compliance',
            classname: 'entity_compliance',
        },
        SERVICE_PROVIDER_USER: {
            default_group_name: 'Service Provider Users',
            role_id: 'entity_sp_user',
            role_name: 'entity service provider user',
            classname: 'entity_sp_user',
        },
    },
    SERVICE_PROVIDER: {
        ADMINISTRATOR: {
            default_group_name: 'Administrators',
            role_id: 'staff_admin',
            role_name: 'staff admin',
            classname: 'sp_administrator',
            type: 'sp_role',
        },
        USER: {
            default_group_name: 'Users',
            role_id: 'staff_user',
            role_name: 'staff user',
            classname: 'sp_user',
            type: 'sp_role',
        },
        BOOKKEEPING_ADMINISTRATOR: {
            default_group_name: 'Bookkeeping Administrators',
            role_id: 'staff_bookkeeper_admin',
            role_name: 'staff bookkeeper admin',
            classname: 'sp_bookkeeper_admin',
            type: 'hidden',
        },
        BOOKKEEPING_USER: {
            default_group_name: 'Bookkeeping Users',
            role_id: 'staff_bookkeeper_user',
            role_name: 'staff bookkeeper user',
            classname: 'sp_bookkeeper_user',
            type: 'hidden',
        },
    },
    ZAVE: {
        SYSTEM_ADMIN: {
            default_group_name: 'Zave System Administrators',
            role_id: 'zave_system_admin',
            role_name: 'zave system admin',
            classname: 'system_admin',
        },
        SYSTEM_ENGINEERS: {
            default_group_name: 'Zave System Engineers',
            role_id: 'zave_system_engineer',
            role_name: 'zave system engineer',
            classname: 'system_engineers',
        },
        SYSTEM_HELPDESK: {
            default_group_name: 'Zave System Helpdesk',
            role_id: 'zave_system_helpdesk',
            role_name: 'zave system helpdesk',
            classname: 'system_helpdesk',
        },
    },
};
module.exports = USER_GROUPS;
